import { Component, Inject, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';
import { ListagemRequisicaoFinanceira } from '@app/models/listagem-requisicao-financeira.model';
import { Instancia } from '@app/models/processo.model';
import { RequisicaoFinanceira, RequisicaoFinanceiraAdvogados, RequisicaoFinanceiraHistorico } from '@app/models/requisicao-financeira.model';
import { IdDescricao } from '@app/models/util/id-descricao';
import { ComunicacaoComponentesService } from '@app/services/comunicacao-componentes.service';
import { ConsultasService } from '@app/services/consultas.service';
import { FinanceiroProcessoService } from '@app/services/financeiro-processo.service';
import { ProcessoService } from '@app/services/processo.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { INgxSelectOption } from 'ngx-select-ex';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-precatorio',
  templateUrl: './precatorio.component.html'
})
export class PrecatorioComponent implements OnInit {
  private subscription: Subscription;
  private processoId: number = 0;

  @Input() processoArquivado: boolean = false;

  totalRequerido: number = 0;
  totalCliente: number = 0;
  totalEscritorio: number = 0;
  totalSubstabelecido: number = 0;
  totalEncaminhador: number = 0;
  totalAdvogados: number = 0;
  totalLiquido: number = 0;

  aguardando: boolean = false;

  lstPrecatorio: ListagemRequisicaoFinanceira[] = [];
  lstHistorico: RequisicaoFinanceiraHistorico[] = [];
  lstErros: string[];

  lstInstancias: Instancia[];
  lstOrgaosJudiciario: IdDescricao[];
  lstAdvogados: IdDescricao[];

  objetoPrecatorio: RequisicaoFinanceira = new RequisicaoFinanceira('PRECATORIO');
  historico: RequisicaoFinanceiraHistorico = new RequisicaoFinanceiraHistorico();

  @ViewChild('modalPrecatorioForm', { static: true }) modalFormRef: TemplateRef<any>;
  modalPrecatorioForm: BsModalRef;
  tituloModalPrecatorioForm: string;

  @ViewChild('modalHistoricoForm', { static: true }) modalHistoricoFormRef: TemplateRef<any>;
  modalHistoricoForm: BsModalRef;
  tituloModalHistoricoForm: string;

  @ViewChild('modalHistorico', { static: true }) modalHistoricoRef: TemplateRef<any>;
  modalHistorico: BsModalRef;
  tituloModalHistorico: string;

  modalConfirmaExclusao: BsModalRef;

  constructor(
    @Inject(ToastrService) public toastr: ToastrService,
    private modalService: BsModalService,
    private processoService: ProcessoService,
    private consultasService: ConsultasService,
    private financeiroProcessoService: FinanceiroProcessoService,
    private comunicacaoComponentesService: ComunicacaoComponentesService,
    private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.subscription = this.comunicacaoComponentesService.obtemClick().subscribe(
      (valor: number) => {
        if(valor === 3){
          this.inicializaComponente();
          this.subscription.unsubscribe();
        }
      });
  }

  //Métodos de busca
  inicializaComponente(){
    this.route.parent.params.subscribe((params) => {
      this.processoId = params['id'];
      this.obterTodos();
    }
    );
  }

  obterTodos(){
    this.financeiroProcessoService.obterTodosPrecatorio(this.processoId).subscribe(
      (data) => {
        this.lstPrecatorio = data;
        this.somaTotais(data);
      },
      () => this.toastr.error('Recarregue a página para tentar novamente.', 'Problema ao pesquisar!')
    );
  }

  //Métodos de criação e edição
  gravarPrecatorio(){
    this.aguardando = true;
    this.objetoPrecatorio.ProcessoId = this.processoId;

    if(!this.validaAdvogados()){
      this.aguardando = false;
      return;
    }

    if(!this.objetoPrecatorio.DataAutuacao && this.objetoPrecatorio.Recebido){
      this.toastr.error("Não é possivel marcar como recebido.", "Data de autuação obrigatória!");
      this.aguardando = false;
      return;
    }

    this.financeiroProcessoService.gravarPrecatorio(this.objetoPrecatorio).subscribe(
      () => {
        this.toastr.success(`Precatório ${this.objetoPrecatorio.Id > 0 ? 'editado' : 'criado'} com sucesso!`);
        this.obterTodos();
        this.fecharModalPrecatorioForm();
      },
      (error) => {
        error.error.errors.length > 1 ?
        this.lstErros = error.error.errors :
        this.toastr.error(error.error.errors[0]);
        this.aguardando = false;
      }
    )
  }

  gravarHistorico(){
    this.aguardando = true;

    this.financeiroProcessoService.gravarHistoricoRequisicaoFinanceira(this.historico).subscribe(
      () => {
        this.aguardando = false;
        this.toastr.success(`Historico ${this.historico.Id > 0 ? 'editado' : 'adicionado'} com sucesso!`);
        this.fecharModalHistoricoForm();
      },
      () => { 
        this.aguardando = false;
        this.toastr.error('Não foi possível salvar histórico');
      }
    );
  }

  //Controles de modal
  abreConfirmarModal(precatorioId: number){
    this.modalConfirmaExclusao = this.modalService.show(ModalConfirmarComponent);
    this.modalConfirmaExclusao.content.mensagem = 'Deseja realmente deletar este Precatório?';
    this.modalConfirmaExclusao.content.confirmar = () => {
      this.financeiroProcessoService.excluirRequisicaoFinanceira(precatorioId).subscribe(
        () => {
          this.toastr.success('Precatório excluído com sucesso!');
          this.obterTodos();
        },
        (error) => this.toastr.error(error.error.errors[0])
      );
    };
  }

  abreModalPrecatorioForm(precatorioId: number = 0){
    const existente = precatorioId > 0;

    if(existente){
      this.financeiroProcessoService.obterRequisicaoFinanceiraPorId(precatorioId).subscribe(data => { 
        this.objetoPrecatorio = data;
        this.objetoPrecatorio.DataAutuacao = data.DataAutuacao?.split('T')[0];
        this.objetoPrecatorio.DataPrevisaoRecebimento = data.DataPrevisaoRecebimento?.split('T')[0];
      });
    }

    this.consultasService.consultar('ORGAODOJUDICIARIO').subscribe(data => this.lstOrgaosJudiciario = data);
    this.consultasService.consultar('ADVOGADO').subscribe(data => this.lstAdvogados = data);
    this.processoService.ObterInstancias(this.processoId).subscribe(data => this.lstInstancias = data);

    this.tituloModalPrecatorioForm = `${existente ? 'EDITAR' : 'NOVO'} PRECATÓRIO`;
    this.modalPrecatorioForm = this.modalService.show(this.modalFormRef, {
        class: 'modal-lg',
        keyboard: false,
        ignoreBackdropClick: true
      });
  }

  fecharModalPrecatorioForm(){
    this.modalPrecatorioForm.hide();
    this.lstErros = [];
    this.objetoPrecatorio = new RequisicaoFinanceira('PRECATORIO');
    this.lstInstancias = [];
    this.aguardando = false;
  }

  abreModalHistoricoFormCriacao(precatorioId: number){
    this.tituloModalHistoricoForm = `ADICIONAR HISTÓRICO PRECATÓRIO Nº ${precatorioId}`;
    this.historico.RequisicaoFinanceiraId = precatorioId;

    this.modalHistoricoForm = this.modalService.show(this.modalHistoricoFormRef, {
      class: 'modal-md',
      keyboard: false,
      ignoreBackdropClick: true
    });
  }

  abreModalHistoricoFormEdicao(indexLista: number){
    let hist = this.lstHistorico[indexLista];
    this.tituloModalHistoricoForm = `EDITAR HISTÓRICO Nº ${hist.Id}`;
    this.historico.Id = hist.Id;
    this.historico.Descricao = hist.Descricao;

    this.modalHistoricoForm = this.modalService.show(this.modalHistoricoFormRef, {
      class: 'modal-md',
      keyboard: false,
      ignoreBackdropClick: true
    });
  }

  fecharModalHistoricoForm(){
    this.modalHistoricoForm.hide();
    if(this.historico.Id > 0)
      this.fecharModalHistorico();
    this.historico = new RequisicaoFinanceiraHistorico();
  }

  abreModalHistorico(precatorioId: number){
    this.tituloModalHistorico = `HISTÓRICO PRECATÓRIO Nº ${precatorioId}`
    this.financeiroProcessoService.obterHistoricoRequisicaoFinanceira(precatorioId).subscribe(
      (data) => {
        this.lstHistorico = data;
        if(data.length > 0)
          this.modalHistorico = this.modalService.show(this.modalHistoricoRef, { class: 'modal-lg' });
        else
          this.toastr.info('Precatório não possui histórico ainda');
      }
    );
  }

  fecharModalHistorico(){
    this.modalHistorico.hide();
  }

  //Controles de formulários
  searchCallback = (search: string, item: INgxSelectOption) => {
    if (search.trim() === '') {
      return true;
    } else {
      return item.text && item.text.toLowerCase().includes(search.toLowerCase());
    }
  }

  validaAdvogados(){
    const advogadoVazio = this.objetoPrecatorio.HonorariosAdvogados.find(x => Number(x.PercentualAdvogado) === 0 || Number(x.AdvogadoId) === 0);
    
    if(advogadoVazio){
      this.toastr.error('Remova advogados não preenchidos!');
      this.aguardando = false;
      return false;
    }

    return true;
  }

  removerAdvogado(index: number) {
    this.objetoPrecatorio.HonorariosAdvogados.splice(index, 1);
  }

  adicionarAdvogado() {
    const adv = new RequisicaoFinanceiraAdvogados(0, 0);
    this.objetoPrecatorio.HonorariosAdvogados.push(adv);
  }

  completaCliente() {
    this.sanitizar();
    this.objetoPrecatorio.PercentualCliente = Number((100 - this.objetoPrecatorio.PercentualEscritorio).toFixed(2));
  }

  completaEscritorio() {
    this.sanitizar();
    this.objetoPrecatorio.PercentualEscritorio = Number((100 - this.objetoPrecatorio.PercentualCliente).toFixed(2));
  }

  sanitizar() {
    if (this.objetoPrecatorio.PercentualCliente.toString().indexOf(','))
      this.objetoPrecatorio.PercentualCliente = Number(this.objetoPrecatorio.PercentualCliente.toString().replace(',', '.'));
    if (this.objetoPrecatorio.PercentualEscritorio.toString().indexOf(','))
      this.objetoPrecatorio.PercentualEscritorio = Number(this.objetoPrecatorio.PercentualEscritorio.toString().replace(',', '.'));
  }

  private somaTotais(lista: ListagemRequisicaoFinanceira[]){
    this.zeraTotais();
    lista.forEach(item => {
      this.totalRequerido += item.ValorRequerido;
      this.totalCliente += item.ValorCliente;
      this.totalEscritorio += item.ValorEscritorio;
      this.totalEncaminhador += item.ValorEncaminhador;
      this.totalSubstabelecido += item.ValorSubstabelecido;
      this.totalAdvogados += item.ValorAdvogados;
      
    });

    this.totalLiquido = this.totalEscritorio - this.totalSubstabelecido - this.totalEncaminhador - this.totalAdvogados;
  }

  private zeraTotais(){
    this.totalRequerido = 0;
    this.totalCliente = 0;
    this.totalEscritorio = 0;
    this.totalEncaminhador = 0;
    this.totalSubstabelecido = 0;
    this.totalAdvogados = 0;
  }
  
}
